import { render, staticRenderFns } from "./Users-info.vue?vue&type=template&id=474c7c3e&"
import script from "./Users-info.vue?vue&type=script&lang=js&"
export * from "./Users-info.vue?vue&type=script&lang=js&"
import style0 from "./Users-info.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports